import { createContext, useContext, useState } from 'react';

const ArtworkDrawerContext = createContext(null);

export const useArtworkDrawer = () => {
  const context = useContext(ArtworkDrawerContext);
  if (!context) {
    throw new Error('useArtworkDrawer must be used within ArtworkDrawerProvider');
  }
  return context;
};

export const ArtworkDrawerProvider = ({ children, ...props }) => {
  const [drawer, setDrawer] = useState({
    show: false,
    component: null,
    allowClickOutsideClose: false,
  });

  const openDrawer = ({ component, allowClickOutsideClose = false }) => {
    setDrawer({
      show: true,
      component,
      allowClickOutsideClose,
    });
  };

  const closeDrawer = () => {
    setDrawer({
      show: false,
      component: null,
      allowClickOutsideClose: false,
    });
  };

  const setDrawerComponent = ({ component }) => {
    setDrawer({
      ...drawer,
      component,
    });
  };

  return (
    <ArtworkDrawerContext.Provider
      value={{ drawer, openDrawer, closeDrawer, setDrawerComponent }}
      {...props}
    >
      {children}
    </ArtworkDrawerContext.Provider>
  );
};
